import React from "react";
import { Container, Box, Typography, Button } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";

const uploadedFiles = [
  { id: 1, name: "Project_Proposal.pdf", type: "pdf", url: "/C:/Users/vc/Downloads/sample.pdf" },
  { id: 2, name: "Meeting_Notes.docx", type: "docx", url: "/files/Meeting_Notes.docx" },
  { id: 3, name: "Final_Report.pdf", type: "pdf", url: "/files/Final_Report.pdf" },
];

const FileDisplay = () => {
  const openInGoogleDocs = (file) => {
    const googleDocsUrl = `https://docs.google.com/viewer?url=${window.location.origin}${file.url}`;
    window.open(googleDocsUrl, "_blank");
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Uploaded Files
      </Typography>
      {uploadedFiles.map((file) => (
        <Box
          key={file.id}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            mb: 2,
            borderRadius: 2,
            boxShadow: 2,
            bgcolor: "#f9f9f9",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {file.type === "pdf" ? (
              <PictureAsPdfIcon sx={{ color: "red", fontSize: 40, mr: 2 }} />
            ) : (
              <DescriptionIcon sx={{ color: "blue", fontSize: 40, mr: 2 }} />
            )}
            <Typography variant="body1" noWrap>
              {file.name}
            </Typography>
          </Box>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => openInGoogleDocs(file)}
          >
            View
          </Button>
        </Box>
      ))}
    </Container>
  );
};

export default FileDisplay;